var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKotlin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "images_9_1_",
    "data-name": "images (9) (1)",
    width: 60,
    height: 60,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAADaElEQVRogdXbO2gVQRQG4BPU4ANTiIJgIdrYaSk2YmMTQQQtRK1SaJEI4iO5imBELTSJz2iMBg2RBAmCQdEigmJhk87GSkFQsRGMYmx8HNmwG37GvbszO2fO7v1hm3vnkY8zk5u7m2li5o9E1EJETHZJ2jXFl0vmEdFiIjpGRL1xv2VE9IKI1jiO5ZIFRLSQiNqJ9TPIzBRfS5j5rdJP0BPNGU36LX7hr+Xlk4uAjVbXayVsVzKvK9gnNwEbXa+UsDWcVwt8z8A+F8LkpWbM6wQumgfGpJNlYW3AvnlqTPhQCduZhs0D++aZMdmoEja1sqHBL42JBgQgNjmeha0H9s2UMUmfEjazsmlgibxh5maY4JwStssGm4C/C036npmXwuCnhMbNi1VlpcGfmHkFDNwZ1jiX3D0bAvyFmVfBoB2CoKw4VVYKPM3Ma2HAfeGds7Hes5LgH8y8DgbbIYyql0KV9QX/Yub1MNA2Hav7npUCb4RBtgaApcUbWxS8BQbYpGMtvmd9wa3QeQMz/w6ITOK1Z33AO6Fj9MtqJrxVZhkXAe+GTquZ+asCVrSyLuA26LCSmT8rYMX2rCu4HRovZ+YPCljxZWwLxrsGLcz8rtGxWeBuaNQcf+0LnSB71gbcazSaUsAG27Np4GmY+JrRQON2qkplEfwznti8Uf5EARt8z6aBozw23phQwKpWFsF3jBc1bqeq7dk0MF63FLBY2cNlgi8pYx/Fr02UAda4nYrLeNx4b1wTfEIBi3+1jdVpc18LHDpY2ZGcucY0wCG/1+Ln7LBln9HQYKknD2awskOOfc0H6JUH4569UXCMkUYBY2Uve441XHUwfs5KPSYVrbQkGCt7XmjMJGKVlgIj9qyM8b/crQoYsaGfCQ+VDcY9e1IQlpXbZYGxsjUd61wGtcH4Oav1tN/MgBYYK3s0vCsz10ODcc8eKQGYlv5QYMQe0jXlxrzb6g3GZdxeMq5erkqBEXugPI9V+nzBuIz3VwiWlZ6iYKxsWzUs1rngCkbs3oqi8hJ9gUkFm/9cist4V/UcTjmTBsaHaXgPansDgGxy2gT/iTvhMm6ttsE53Qhm4zfbngaCuORK5IsOS3UQUX98rG0zEU3GR9dmChx5i47pZR3pSzu6h+2T430247gcA5xPRIuI6OA/5tD3IoM0gUYAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKotlin);
export default __webpack_public_path__ + "static/media/kotlin.347b2f1749a1bb8bb317a4c316e89325.svg";
export { ForwardRef as ReactComponent };